// extracted by mini-css-extract-plugin
export default {"action":"manage-skill-categories_action__fxPuc","button":"manage-skill-categories_button__9uXJY"};